var map = {
	"./australia": 578,
	"./australia.js": 578,
	"./cricinfo/africa": 567,
	"./cricinfo/africa.js": 567,
	"./cricinfo/australia": 568,
	"./cricinfo/australia.js": 568,
	"./cricinfo/bangladesh": 569,
	"./cricinfo/bangladesh.js": 569,
	"./cricinfo/global": 570,
	"./cricinfo/global.js": 570,
	"./cricinfo/india": 571,
	"./cricinfo/india.js": 571,
	"./cricinfo/newzealand": 572,
	"./cricinfo/newzealand.js": 572,
	"./cricinfo/pakistan": 573,
	"./cricinfo/pakistan.js": 573,
	"./cricinfo/srilanka": 574,
	"./cricinfo/srilanka.js": 574,
	"./cricinfo/unitedkingdom": 575,
	"./cricinfo/unitedkingdom.js": 575,
	"./cricinfo/unitedstates": 576,
	"./cricinfo/unitedstates.js": 576,
	"./en-global": 579,
	"./en-global.js": 579,
	"./india": 580,
	"./india.js": 580,
	"./philippines": 581,
	"./philippines.js": 581,
	"./southafrica": 582,
	"./southafrica.js": 582,
	"./unitedkingdom": 583,
	"./unitedkingdom.js": 583,
	"./unitedstates": 584,
	"./unitedstates.js": 584
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 577;



//////////////////
// WEBPACK FOOTER
// ../app/lib/utils/editions/config ^\.\/.*$
// module id = 577
// module chunks = 0